export const heroMain = {
	reverse: true,
	inverse: false,
	topLine: {
		// text: 'Free',
		// location: 'Park City, Utah',
	},
	headline: 'Find the best events',
	description:
		'Welcome New Year with Wondergarden on waterfront. Celebrate with world-class international acts, roaming performers, children’s performers and entertainment',
	buttonLabel: 'Find out more',
	imgStart: 'start',
	img: './assets/heromain1.jpg',
	start: 'true',
};

const heroOne = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'Free',
		location: 'Park City, Utah',
	},
	headline: 'Wondergarden',
	description:
		'Welcome New Year with Wondergarden on waterfront. Celebrate with world-class international acts, roaming performers, children’s performers and entertainment',
	buttonLabel: 'Find out more',
	imgStart: 'start',
	img: './assets/hero1.jpg',
	start: 'true',
};

const heroTwo = {
	reverse: false,
	inverse: false,
	topLine: {
		text: 'Paid',
		location: 'Hard Rock Stadium, Miami, Florida',
	},
	headline: 'St Jerome’s Laneway Festival',
	description:
		'Full of fresh, original and ground-breaking music, the festival’s set in the urban playground on the center.',
	buttonLabel: 'Find out more',
	imgStart: 'start',
	img: './assets/hero6.jpg',
	start: 'true',
};

const heroThree = {
	reverse: true,
	inverse: true,
	topLine: {
		location: 'New Orleans, Louisiana',
		text: 'Exclusive',
	},
	headline: 'Pride Festival',
	description:
		'This two-week festival brings together a chocka social calendar and array of events including theatre and cabaret, music, visual arts exhibitions and installations, film and literature',
	buttonLabel: 'Find out more',

	imgStart: '',
	img: './assets/hero7.jpg',
	start: 'true',
};

const heroFour = {
	reverse: false,
	inverse: false,
	topLine: {
		location: 'Augusta National Gold Club, Georgia',
		text: 'Paid',
	},
	headline: 'Taste of the Night',
	description:
		'Try a selection of signature dishes from finest restaurants as you stroll through most glamorous food festival.',
	buttonLabel: 'Find out more',
	imgStart: '',
	img: './assets/hero3.jpg',
	start: 'true',
};

export const heroData = [heroOne, heroTwo, heroThree, heroFour];
